document.addEventListener('reintegrationFormSubmitted', (event) => {
    const { form, data } = event.detail;
    
    if (data.success) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'form_submission_success',
            'form_id': form.id || 'unknown',
            'form_name': data.data?.form_name || 'reIntegration Form'
        });
    }
}); 
